import { Directive, ElementRef, Input, OnInit } from "@angular/core";

@Directive({
    selector: '[fnAutoFocus]'
})
export class FnAutoFocusDirective implements OnInit {
    private focus = true;
    constructor(private el: ElementRef){ }

    ngOnInit() {
    if (this.focus) {
        //Otherwise Angular throws error: Expression has changed after it was checked.
        setTimeout(() => {
            this.el.nativeElement.focus();
        });
    }
}

    @Input() set fnAutoFocus(condition: boolean) {
        this.focus = condition !== false;
    }
}